export const SET_USER_PROFILE = '[Auth] Set logged in user profile';
export const SET_USER_EMAIL = '[Auth] Set logged in user email info';
export const SET_USER_IDENTITY_ID = '[Auth] Set logged in user identity ID';
export const SET_USER_INFO = '[Auth] Set logged in user info';

export function setUserProfile(payload) {
  return {
    type: SET_USER_PROFILE,
    payload: payload
  }
}

export function setUserEmail(payload) {
  return {
    type: SET_USER_EMAIL,
    payload: payload
  }
}

export function setUserIdentityId(payload) {
  return {
    type: SET_USER_IDENTITY_ID,
    payload: payload
  }
}

export function setUserInfo(payload) {
  return {
    type: SET_USER_INFO,
    payload: payload
  }
}

